/* eslint-disable @typescript-eslint/naming-convention */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GetProductByIdDataInterface } from 'features/Product/@types/ProductMasterDetail'
import { GetPPNResponseType } from 'features/Product/services/productAdd'
import { DiscoveryLabelType } from 'redux/productLabel'

export const SLICE_NAME_PRODUCT_MASTER_DETAIL = 'productMasterDetail'

interface ProductDetailStateInterface {
  isLoading: boolean
  ppnList: GetPPNResponseType[]
  productDetail: GetProductByIdDataInterface
  productLabelImage: Nullable<DiscoveryLabelType>
  productLabelPromotion: Nullable<DiscoveryLabelType>
}

const initialState: ProductDetailStateInterface = {
  isLoading: false,
  ppnList: [],
  productDetail: {
    summary_uom: {
      outer_uom: null,
      inner_uom: null,
      base_uom: null,
    },
    product_label_image_id: 0,
    product_label_promotion_id: 0,
    product_id: 0,
    product_sku_no: '',
    product_name: '',
    base_uom: {
      active: false,
      id: '',
      description: '',
      group: '',
    },
    product_description: '',
    weight: '',
    length: '',
    width: '',
    height: '',
    active: false,
    type: {
      id: 0,
      name: '',
    },
    brand: {
      id: 0,
      name: '',
    },
    bom_category: '',
    is_consignment: false,
    relabeled_in_hub: false,
    relabeled_in_wh: false,
    use_standard_ned: false,
    ppn: {
      key: '',
      label: '',
    },
    mslod: 0,
    mslor: 0,
    msltc: 0,
    max_inventory_balance: 0,
    max_days_of_inventory: 0,
    min_days_of_inventory: 0,
    product_categories: [],
    product_image_urls: [],
    product_image_paths: [],
    is_virtual_bom_component: false,
    product_virtual_components: [],
    item_code: '',
    netsuite_id: 0,
    slug: '',
    product_translation: {
      name: { id_ID: '' },
      description: { id_ID: '' },
    },
    selling_unit_grammation_description: '',
    attributes: {
      business_unit: null,
      company: null,
      source_status: {
        key: '',
        label: '',
      },
      produced_by: '',
      product_age: 0,
      flush_out_age: 0,
      recycling_age: 0,
      expiration_reminder: 0,
      max_qty: 0,
      max_qty_duration: 0,
      business_taggings: [],
      bpom: '',
      sni: '',
      pirt: '',
      mui: '',
      shelf: '',
      cogs: 0,
      harga_eceran_tertinggi: 0,
      harga_eceran_terendah: 0,
      het_docs_agreement: '',
      freebies_period_start_date: '',
      freebies_period_end_date: '',
      seasonal_sku_period_start_date: '',
      seasonal_sku_period_end_date: '',
      exclusive_launch_period_start_date: '',
      exclusive_launch_period_end_date: '',
      asset_id_storage_wh: 0,
      asset_id_storage_hub: 0,
      asset_id_outbound: 0,
      palletization_detail: 0,
      max_stackability: 0,
      total_qty_per_pallet: 0,
      max_qty_per_koli: 0,
      product_placement: {
        key: '',
        label: '',
      },
      packaging_type: '',
      packaging_thickness: 0,
      receiving_uom: {
        key: '',
        label: '',
      },
      instruction_receiving: '',
      picking_uom: {
        key: '',
        label: '',
      },
      instruction_picking: '',
      purchase_uom: '',
      image_link: '',
      max_qty_per_bin_at_wh: 0,
      max_qty_per_bin_at_hub: 0,
      max_lead_time_outside_temperature: 0,
      vendor_uom: {
        key: '',
        label: '',
      },
    },
    sku_movement_handling: '',
    is_food: false,
    is_seasonal_sku: false,
    is_exclusive_launch: false,
    is_high_value: false,
    is_high_risk: false,
    is_halal: false,
    is_substitute: false,
    is_allow_rfid: false,
    is_bundling: false,
    is_qr: false,
    is_allow_mix_sku: false,
    is_allow_het: false,
    is_fragile: false,
    is_rotten: false,
    is_melting: false,
    is_single_packaging: false,
    is_refill: false,
    is_auto_active_super: false,
    is_special_handling: false,
    is_critical_status: false,
    is_sharp: false,
    is_eggs: false,
    created_at: '',
    created_by: '',
    updated_at: '',
    updated_by: '',
    primary_category: {
      id: 0,
      name: '',
      mslod: 0,
      mslor: 0,
      msltc: 0,
    },
    product_category_ids: [],
    storage_handling: {
      id: 0,
      name: '',
      type: '',
      min_temperature: undefined,
      max_temperature: undefined,
    },
    is_broken_receipt: false,
    is_leaking: false,
    is_slipped: false,
    is_flammable: false,
  },
  productLabelImage: null,
  productLabelPromotion: null,
}
const productMasterDetail = createSlice({
  name: SLICE_NAME_PRODUCT_MASTER_DETAIL,
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    resetStateProductMasterDetail: () => initialState,
    setProductDetail: (state, action: PayloadAction<GetProductByIdDataInterface>) => {
      const { attributes, ...rest } = action.payload
      state.productDetail = {
        ...state.productDetail,
        ...rest,
        attributes: {
          ...state.productDetail.attributes,
          ...attributes,
        },
      }
    },
    setPPNList: (state, action) => {
      state.ppnList = action.payload
    },
    setProductLabelImage: (state, action: PayloadAction<Nullable<DiscoveryLabelType>>) => {
      state.productLabelImage = action.payload
    },
    setProductLabelPromotion: (state, action: PayloadAction<Nullable<DiscoveryLabelType>>) => {
      state.productLabelPromotion = action.payload
    },
  },
})

export const {
  setIsLoading,
  resetStateProductMasterDetail,
  setProductDetail,
  setPPNList,
  setProductLabelImage,
  setProductLabelPromotion,
} = productMasterDetail.actions

export default productMasterDetail.reducer
